import React from 'react';
import { Handle, Position, type NodeProps } from '@xyflow/react';

import { Icon } from '@/nova/components';

import type { FrameFlowNode } from '../graph';
import {
  Card,
  HeaderRow,
  PlaceholderText,
  Pill,
  PromoChip,
  ThumbFrame,
  ThumbImg,
  ThumbPlaceholder,
} from './nodes.styles';

/**
 * The storyboard origin: F0, the locked promotion key visual the first beat animates from. Frames are
 * no longer user-facing nodes — each beat's end frame is derived automatically, and the worker seams
 * each clip's actual last rendered frame into the next beat's start — so this renders a read-only
 * origin chip only. The brand logo + domain live in their own Brand card (see BrandNode).
 */
export const FrameNode = ({ data }: NodeProps<FrameFlowNode>): React.ReactElement => {
  return (
    <Card $width={220} $status={data.status}>
      <HeaderRow>
        <Pill
          text={data.promotionIndex != null ? 'Key visual {{n}}' : 'Key visual'}
          placeholders={data.promotionIndex != null ? { n: data.promotionIndex + 1 } : undefined}
        />
        {data.promotionName ? <PromoChip raw text={data.promotionName} /> : null}
      </HeaderRow>

      {data.imageUrl ? (
        <ThumbFrame $ratio={data.thumbRatio} $dim={false}>
          <ThumbImg src={data.imageUrl} alt="" $position="right" />
        </ThumbFrame>
      ) : (
        <ThumbPlaceholder $ratio={data.thumbRatio}>
          <Icon name="video" size={20} />
          <PlaceholderText text="Key visual" />
        </ThumbPlaceholder>
      )}

      {/* A key visual hangs ABOVE its beat and feeds it top-down via the bottom source. F0 also RECEIVES the
          Setup control card's connector on its left ('in'); the multi-promo kv-* cards reuse this node and
          simply leave that target handle unconnected. */}
      <Handle type="target" position={Position.Left} id="in" />
      <Handle type="source" position={Position.Bottom} id="out" />
    </Card>
  );
};

export default FrameNode;
